import React from 'react';
import cx from 'classnames';
export const Handle = ({ 
// your handle component
handle: { id, percent }, disabled, getHandleProps, showHandle, onHover, }) => {
    return (React.createElement("div", Object.assign({ onMouseEnter: () => onHover(true), onMouseLeave: () => onHover(false), className: cx('playback_handle', { 'playback_handle--forceshow': showHandle }), style: {
            left: `${percent}%`,
            position: 'absolute',
            marginLeft: '-8px',
            marginTop: '-5px',
            zIndex: 3,
            width: 16,
            height: 16,
            border: 0,
            cursor: disabled ? 'unset' : 'pointer',
            borderRadius: '50%',
            backgroundColor: disabled ? '#666' : '#0b6bf2',
            color: '#333',
        } }, getHandleProps(id))));
};
//# sourceMappingURL=Handle.js.map